import React, { useState } from "react";
import { FiSearch, FiX } from "react-icons/fi";

interface SearchTableInputProps {
  onInputChange: (value: string) => void;
  placeholderText?: string;
  wrapperClassName?: string;
  inputClassName?: string;
}

export const SearchTableInput: React.FC<SearchTableInputProps> = ({
  onInputChange,
  placeholderText = "Search...",
  wrapperClassName = "",
  inputClassName = "",
}) => {
  const [value, setValue] = useState("");

  const handleChange = (v: string) => {
    setValue(v);
    onInputChange(v);
  };

  const handleClear = () => {
    setValue("");
    onInputChange("");
  };
  return (
    <div
      className={[
        "relative w-full",
        "rounded-lg border border-slate-200 dark:border-slate-700",
        "bg-slate-100 dark:bg-slate-800",
        "focus-within:ring-2 focus-within:ring-del-green/40",
        wrapperClassName,
      ].join(" ")}
    >
      <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 dark:text-slate-300" />
      <input
        type="text"
        placeholder={placeholderText}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        className={[
          "w-full h-10 pl-10 pr-3",
          "bg-transparent outline-none",
          "text-sm text-slate-900 dark:text-slate-100 placeholder:text-slate-500 dark:placeholder:text-slate-400",
          "rounded-lg",
          inputClassName,
        ].join(" ")}
      />

      {value && (
        <button
          type="button"
          aria-label="Clear search"
          onClick={handleClear}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-700 dark:text-slate-300 dark:hover:text-slate-100"
        >
          <FiX />
        </button>
      )}
    </div>
  );
};